import { createContext, useContext } from 'react';
import colors from 'styles/colors';

export type AnnotationColors = {
  defaultColor: string;
  hoverColor: string;
};

// @ts-expect-error [EN-10263] - TS2322 - Type 'Context<{ defaultColor: "#FFFF66"; hoverColor: "#99ff66"; }>' is not assignable to type 'Context<AnnotationColors>'.
export const AnnotationColorsContext: React.Context<AnnotationColors> = createContext({
  defaultColor: colors.ugcAnnotation,
  hoverColor: colors.ugcAnnotationHover,
});

export function useAnnotationColors(): AnnotationColors {
  return useContext(AnnotationColorsContext);
}
